export default __webpack_public_path__ + "media/98566a4dc8f7988051e0c272580455829d06bb894bd98360f2f0174c68ac58d6.svg";